/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import auth from "@/services/authService";
// import firebase from "firebase/app";
// import "firebase/auth";
import { getApplicationLocalStorageItem } from "../../helpers";

export default {
  user: {},
  token: "",
  api_url: "",
  app_token: "",
  delegator_url: "",
  use_microsoft_sso: false,
  api_integration_token: "",
  login_parameters: {},
  role: {},
  roleLogo: null,
  roleLogoHeight: 40,
  moduleFieldUpdates: [],
  currentModuleName: "",
  currentModuleNameEn: "",
  isUserLoggedIn: () => {
    let isAuthenticated = false;

    // get firebase current user
    if (getApplicationLocalStorageItem("accessToken")) {
      isAuthenticated = true;
    }
    return isAuthenticated;
  },
  menu: [],
  layout: {},
  general: {},
  languages: {},
  web: {},
  menuLayout: {},
  availableRoles: []
};
